import { CommentsSortItems } from './CommentsSortItems';

export class CommentsFilterModel {
    messageId: number;
    SortItem: CommentsSortItems;
    pageNumber: number;
    ObjectType: string;
    pageSize = 999;
}
